var React = require('react');

function ToggleButton (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"288","height":"199","fill":"white","key":0}),React.createElement("path",{"d":"M191.5 76.5H286.5V123.5H191.5V76.5Z","stroke":"#737373","key":1}),React.createElement("rect",{"x":"207","y":"88","width":"64","height":"24","fill":"#D8D8D8","key":2}),React.createElement("rect",{"x":"96.5","y":"76.5","width":"95","height":"47","stroke":"#737373","key":3}),React.createElement("rect",{"x":"112","y":"88","width":"64","height":"24","fill":"#D8D8D8","key":4}),React.createElement("path",{"d":"M1 76H97V124H1V76Z","fill":"#737373","key":5}),React.createElement("rect",{"x":"17","y":"88","width":"64","height":"24","fill":"#D8D8D8","key":6})]);
}

ToggleButton.defaultProps = {"width":"288","height":"199","viewBox":"0 0 288 199","fill":"none"};

module.exports = ToggleButton;

ToggleButton.default = ToggleButton;
